import { Button as RAButton } from "react-admin";

const Button = (props) =>
{
  return <RAButton {...props} size="medium" />;
};

export default Button;
